module.exports = require("@babel/runtime/helpers/esm/extends");